<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 17:50:48
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="padding: 20px 0px 0px 20px;">

      <el-form style="display: flex;flex-wrap: wrap;">
            <el-form-item label="老师职级:" style="display: flex;width: 33%;">
                <el-select placeholder="请选择老师职级" v-model="input1" style="width: 100%" clearable filterable>
                    <el-option v-for="item in options"  :key="item.value"  :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>

            <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
              <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddBtns">新增规则</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
            </div>

        </el-form>


        <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
            <el-table-column prop="customerStudent" label="老师职级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="customerIsallpay" label="规则详情" show-overflow-tooltip></el-table-column>
            <el-table-column prop="auditStatus" label="规则状态" show-overflow-tooltip>
              <template slot-scope="scope">
                    <div style="display: flex;justify-content: space-around;color:#61dd39;" v-if="scope.row.auditStatus === 0">启用</div>
                    <div style="display: flex;justify-content: space-around;color:#e53f20;" v-if="scope.row.auditStatus === 1">禁用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <div style="display: flex;justify-content: space-around;">
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(1, scope.row)">详情</el-button>
                        <el-button type="text" style="color:#00aaff;" @click="handleClickView(4, scope.row)">编辑</el-button>
                        <el-button type="text" style="color:#e53f20;" @click="handleClickView(2, scope.row)">禁用</el-button>
                        <el-button type="text" style="color:#61dd39;" @click="handleClickView(3, scope.row)">启用</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageNum" :page-size="pageSize"
            layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>


        <el-dialog  :center="true" :close-on-click-modal="false" :title="titleDialogShow" :visible.sync="titleDialogShowvisible"  @close="titlerejectDialogShowClr" width="70%">
            <el-form :model="form" label-width="100px" :disabled="!isShow">
                <el-form-item label="老师职级">
                    <el-select v-model="form.input1" placeholder="请选择老师职级">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="规则状态">
                  <el-switch  v-model="form.input2" active-text="启用"  inactive-text="禁用"></el-switch>
                </el-form-item>
                <el-form-item label="规则详情">
                    <el-input type="textarea" placeholder="请输入规则详情" maxlength="300" show-word-limit v-model="form.input3" :autosize="{ minRows: 6, maxRows: 6 }"></el-input>
                </el-form-item>
            </el-form>


            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="btns" @click="titlerejectDialogShowClr">取 消</el-button>
                <el-button v-if="isShow" size="small" class="btns" type="primary" @click="titlerejectDialogShowSubt">确 定</el-button>
            </div>

        </el-dialog>



  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { handleStudent, handleTeacher } from "../utils/publicInterface";
import { getStudentsType } from "@/api/fiveClassApi"

 
export default {
  components:{

  },
  data() {
      return{

        options:[
          { value: 1, label: '初级老师'},
          { value: 2, label: '中级老师'},
          { value: 3, label: '高级老师'},
          { value: 4, label: '特级老师'},
        ],

          input1:'',

          dataList:[],

          pageNum: 1,
          pageSize: 10,
          total: 0,

          form:{
              input1:'',
              input2:true,
              input3:'',
          },
          titleDialogShow:'新增规则',
          titleDialogShowvisible:false,

          isShow:true,


      }
  },

  mounted(){

  },


  methods:{


      getApiList(){
          let data = {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              commitId: this.input1,
          }
          axios.post(`${apiBaseUrl}/orderCustomerAudit/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                if(res.data.code === 200){

                  let data = res.data.data
                  this.dataList = data.records
                  this.pageNum = data.current ? data.current : 0
                  this.pageSize = data.size ? data.size : 10
                  this.total = data.total ? data.total : 0

                  this.$message({ message: res.data.message , type: "success" })
                }
          }).catch((err)=>{
              this.$message({ message: err , type: "error" })
          })
      },

      AddBtns(){
        this.titleDialogShowvisible = true
        this.titleDialogShow = '新增规则'
      },

      titlerejectDialogShowSubt(){
        this.titleDialogShowvisible = false
      },

      titlerejectDialogShowClr(){
        this.titleDialogShowvisible = false
      },


      searchBtns(){
          this.getApiList()
      },

      clearBtns(){
          this.input1 = ''
          this.getApiList()
      },

      handleSizeChange(e){
          this.pagepageSizeNum = e
          this.getApiList()
      },

      handleCurrentChange(e){
          this.pageNum = e
          this.getApiList()
      },

      handleClickView(type,itme){
        console.log(itme)
        if(type === 1){
          this.titleDialogShowvisible = true
          this.titleDialogShow = '查看详情'
          this.isShow = false
        }

        if(type === 2){

        }

        if(type === 3){

        }
        if(type === 4){
          this.titleDialogShowvisible = true
          this.titleDialogShow = '编辑规则'
        }

      },

  }

}
</script>


<style scoped lang="less">

  .no-click {
      pointer-events: none;
  }

  .btns{
      background-color: #428BCA;
      border-color: #428BCA;
      color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/PromotionAndProtectionRulesManagement/PromotionAndProtectionRulesManagement.vue